/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useCreateApiKeyMutation,
  CreateApiKeyInput,
  CreateApiKeyMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess?: (data: CreateApiKeyMutation) => void;
};

export function useCreateApiKey({ onSuccess }: Props) {
  const [createApiKeyMutation, { loading }] = useCreateApiKeyMutation({
    onError: () => {
      showError();
    },
    onCompleted: (response) => {
      onSuccess?.(response);
      showSuccess(generateActionSuccessText("API Key")()("created")());
    },
    update(cache, { data }, { variables }) {
      if (data?.createApiKey && variables?.input) {
        cache.modify({
          fields: {
            apiKeys: (existing) => {
              return {
                apiKeys: [existing, variables.input],
              };
            },
          },
        });

        cache.gc();
      }
    },
  });

  function createApiKey(data: CreateApiKeyInput) {
    createApiKeyMutation({
      variables: {
        input: data,
      },
    });
  }

  return [createApiKey, loading] as const;
}
